import { render } from "./SchemaMoveClassificationResult.vue?vue&type=template&id=dbee13e0"
import script from "./SchemaMoveClassificationResult.vue?vue&type=script&lang=js"
export * from "./SchemaMoveClassificationResult.vue?vue&type=script&lang=js"
script.render = render

export default script